import { FlexGrid, Typography, Link } from "@albo-ui/core";
import { FormControlLabel, Checkbox } from '@mui/material';
import { status } from '../../util/DataObject';
import { Divider } from "@mui/material";
import moment from "moment";
moment.locale('es');

export type SectionItemProps = {
	data?: any;
	item?: any;
	options?: any;
	index?: number;
	i?: number;
	widthA?: string;
	widthB?: string;
	height?: string;
	subSections?: any;
	onDisplayImage?: (data: any) => any;
	updateSectionStatusLead?: (data: any) => any;
};

const SectionItem = ({ data, item, options, index, i, onDisplayImage, widthA, widthB, height, subSections, updateSectionStatusLead }: SectionItemProps) => {
	const validateSubSection = (uuid, section) => {
		let v = subSections.filter((a) => a.formUuid === uuid && a.sectionName === section)
		return v.length > 0 ? v[0]["status"] === "completed" ? true : false : false
	}

	const onHandleUpdate = (lead) => {
		let agent = localStorage.session ? JSON.parse(localStorage.session) : {};

        let payload = {
            lead_uuid: data.leadUuid,
            section_name: item.subSection,
            form_uuid: lead.form_uuid,
            status: validateSubSection(lead.form_uuid, item.subSection) ? "pending" : "completed",
            updated_by: agent["email"]
        }
		
		return updateSectionStatusLead(payload);
	}

	const onHandleSection = (uuid, section) => {
		return <FormControlLabel control={<Checkbox checked={validateSubSection(uuid, section)} onChange={() => onHandleUpdate(newData)} />} sx={{ml: 1}} label={null} />
	}

	const catalogs = [
		{ key: "passport", name: "Pasaporte" },
		{ key: "ine", name: "INE" }
	]

	const newData = Array.isArray(data) ? data[index] : data

	const defaultItem = (info= newData, key= item.key) => {
		return <Typography variant="paragraph" style={{width: widthB || "55%", overflowWrap: "break-word"}}>
			{info[key] ||( info[key[0]] && info[key[0]][key[1]]) || "-"}{info[key[0]] && info[key[0]][key[2]] ? ", " + info[key[0]][key[2]] : ""}
		</Typography>
	}
	const transformDate = (info= newData, key= item.key) => {
		let time = moment(info[key]).format("L") ||( info[key[0]] && moment(info[key[0]][key[1]]).format("L")) || "-"
		return <Typography variant="paragraph" style={{width: "55%"}}>{time}</Typography>
	}
	const transformLargeDate = (info= newData, key= item.key) => {
		let time = moment(info[key]).format("LL") || (info[key[0]] && moment(info[key[0]][key[1]]).format("LL")) || "-"
		return <Typography variant="paragraph" style={{width: "55%"}}>{time}</Typography>
	}
	const transformTimeDate = (info= newData, key= item.key) => {
		let time = moment(info[key]).format("LLL") || (info[key[0]] && moment(info[key[0]][key[1]]).format("LLL")) || "-"
		return <Typography variant="paragraph" style={{width: "55%"}}>{time}</Typography>
	}
	const typeParagraph = (children) => {
		return <Typography variant="paragraph" color="lightNeutral" style={{width: widthA || "45%", paddingRight: 25}}>{children || "No aplica"}</Typography>
	}
	const typeText = (children) => {
		return <Typography variant="paragraph" style={{width: widthB || "55%"}}>{children || "No aplica"}</Typography>
	}

    return (
		item.type && item.type === "image" ?
			<Typography variant="paragraph" color="lightNeutral" >
				<Link key={i ? index-i : index} bold onClick={() => onDisplayImage(options ? options[item.key] : newData[item.key])}>
					{item.name}
				</Link>
			</Typography>
		:
		item.type && item.type === "detail" ?
			<Typography variant="paragraph" color="lightNeutral" >
				<Link key={i ? index-i : index} bold href={options ? options[item.key] : newData[item.key]} >
					{item.name}
				</Link>
			</Typography>
		:
		item.type && item.type === "subtitle" ?
			<Typography key={i ? index-i : index} variant="smallTitle" bold style={{margin: "1rem 0 0.1rem"}}>
				{item.name} {item.count && item.count + index} {item.subSection && onHandleSection(newData["form_uuid"], item.subSection)}
			</Typography>
		:
		item.type && item.type === "array" && item.count && newData[item.key] && newData[item.key].length > 0 ?
		newData[item.key].map((p, indice) => {
			return <FlexGrid key={`${item.key}-${index}-${indice}`} container>
					{typeParagraph(item.name +" "+ (item.type === "array" && item.count ? item.count + indice : ""))}
					{typeText(p)} 
				</FlexGrid>
			})
			:
			item.type && item.type === "array2" && newData[item.key] && newData[item.key].length > 0 ?
			newData[item.key]?.map((p, indice) => {
				return <FlexGrid key={`${item.key}-${index}-${indice}`} container style={{display: "flow"}}>
					{Object.keys(item.obj).map((a, b) => {
						return <FlexGrid key={`${a}-${b}-${indice}`} container>
							{typeParagraph(item.obj[a] || "No aplica")}
							{a === "bdate" ? transformDate(p, a) : 
							 a === "gname" ? typeText(`${p['gname']} ${p['lname']} ${p['slname'] || ''} `) 
								: defaultItem(p, a)
							}
						</FlexGrid>

					})}
					<Divider style={{ margin: "auto", marginTop: 3}} />
				</FlexGrid>
			})
		:
		item.type && item.type === "paragraph" ?
			<Typography variant="paragraph">{newData[item.key] || "No aplica"}</Typography>
		:
		item.type && item.type === "element" && item.getData ?
			item.element(item.name, newData[item.key], item.key)
		:
		item.type && item.type === "element" ?
			item.element(newData)
		:
		<FlexGrid key={i ? index-i : index} container>
			{typeParagraph(item.name ? item.name +" "+ (item.type === "array" && item.count ? item.count + index : "") : "No aplica")}
			{
				item.type && item.type === "boolean" ?
					typeText(newData[item.key] ? "Sí" : "No")
				:
				item.type && item.type === "status" ?
					typeText(status.filter((c) => c.value === newData[item.key])[0].label)
				:
				item.type && item.type === "name" ?
					typeText(`${newData['gname']} ${newData['lname']} ${newData['slname']} `)
				:
				item.type && item.type === "date" ?
					transformDate()
				:
				item.type && item.type === "dateLarge" ?
					transformLargeDate()
				:
				item.type && item.type === "timeDate" ?
					transformTimeDate()
				:
				item.type && item.type === "pep" ?
					typeText((newData[item.key] && (newData[item.key] ? "Sí" : "No" )) || "-")
				:
				item.type && item.type === "catalogs" ?
					typeText(catalogs.map((c) => {
						return ((newData[item.key] && c.key === newData[item.key]) && c.name) || (((newData[item.key[0]] && newData[item.key[0]][item.key[1]]) && c.key === newData[item.key[0]][item.key[1]]) && c.name)
					}))
				:			
				item.type && item.type === "link" ?
				options ?
				(options[item.key] ?
					<Link underlined style={{display: "flex", alignItems: "center", width: "55%"}} href={options[item.key]} >
						{options[item.key] && options[item.key].length < 30 ? options[item.key] : item.name}
					</Link>
					: "-"
				) 	: 
				(	
					<Link underlined style={{display: "flex", alignItems: "center", width: "55%"}} href={newData[item.key] || 
						(newData[item.key[0]] && newData[item.key[0]][item.key[1]]) 
					} >
						{newData[item.key] && newData[item.key].length < 30 ? newData[item.key] : 
							newData[item.key[0]] && newData[item.key[0]][item.key[1]] && newData[item.key[0]][item.key[1]].length < 30 ? newData[item.key[0]][item.key[1]] : item.name}
					</Link>
				)
				:
				defaultItem()
			}
		</FlexGrid>	
	)
};

export default SectionItem;
